import { AfterViewInit, Component } from '@angular/core';
import { SyncService } from './sync.service';
import { AppStringsPipe } from "../shared/pipes/appstrings.pipe";
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { default as appString } from '../../assets/resources/appstrings.da.json';


@Component({
  selector: 'app-sync',
  imports: [AppStringsPipe],
  providers: [SyncService],
  templateUrl: './sync.component.html',
  styleUrl: './sync.component.scss',
})
export class SyncComponent implements AfterViewInit {

  readonly snackBarConfig: MatSnackBarConfig = {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      };

  async clickDeleteSync() {
      this.syncService.syncClear();
      this.snackBar.open(appString.SYNC.DELETE_SYNC_SUCCESS, appString.SNACKBAR.OK, this.snackBarConfig);
  }

  async clickDeleteStore() {
      this.syncService.storeClear();
      this.snackBar.open(appString.SYNC.DELETE_STORE_SUCCESS, appString.SNACKBAR.OK, this.snackBarConfig);
  }

  async clickSync() {
    this.syncService.syncData().then((synced) => {
      if (synced) {
        this.snackBar.open(appString.SYNC.SYNCHRONIZATIONSUCCESS, appString.SNACKBAR.OK, this.snackBarConfig);
      }
      else {
        this.snackBar.open(appString.SYNC.SYNCHRONIZATIONNOTNEEDED, appString.SNACKBAR.OK, this.snackBarConfig);
      }

    }).catch((error) => {
      console.error('Sync failed:', error);
      this.snackBar.open(appString.SYNC.SYNCHRONIZATIONFAILURE, appString.SNACKBAR.OK, this.snackBarConfig);
    });

  }

  constructor(
    private syncService: SyncService,
    private snackBar: MatSnackBar,
    ) {
  }



  async ngAfterViewInit() {



  }
}


